// src/config.js
export const config = {
  // Prod — served by the pipeline's Prod stage on coachai.csld.amazon.dev
  // (CloudFront distribution d1obq4snzch1gj). The cutover from Beta is done.
  // Uses Prod Cognito (us-west-2_uqazlzUd7) + Prod API Gateway (1byun2hq08, us-west-2).
  // extraQueryParams skips Cognito hosted UI and goes directly to Amazon Federate (Midway SSO)
  // resulting in one-click sign-in for users with an active Midway session.
  production: {
    redirectUri: "https://coachai.csld.amazon.dev/",
    logoutUri: "https://coachai.csld.amazon.dev/",
    apiEndpoint: "bedrock",
    // Prod API Gateway (us-west-2) — CDK-managed, deployed via CSLDCoachAIBackend-Prod
    apiUrl: "https://1byun2hq08.execute-api.us-west-2.amazonaws.com/prod",
    auth: {
      // Prod Cognito (us-west-2_uqazlzUd7) with FederateOIDC identity provider
      authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_uqazlzUd7",
      client_id: "1485j17ri0ng28luc7bd0373ve",
      redirect_uri: "https://coachai.csld.amazon.dev/",
      post_logout_redirect_uri: "https://coachai.csld.amazon.dev/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
      // Skip Cognito hosted UI and go directly to Amazon Federate (Midway SSO)
      // Results in one-click sign-in for users with an active Midway session
      extraQueryParams: { identity_provider: "FederateOIDC" },
    },
  },
  // Prod CloudFront smoke-test config — the Prod stage's own CloudFront domain,
  // behind coachai.csld.amazon.dev. Useful for checking Prod directly, bypassing
  // the custom domain. Cognito redirects back to the CloudFront URL after login.
  // Prod CloudFront: https://d1obq4snzch1gj.cloudfront.net
  prodCloudFront: {
    redirectUri: "https://d1obq4snzch1gj.cloudfront.net/",
    logoutUri: "https://d1obq4snzch1gj.cloudfront.net/",
    apiEndpoint: "bedrock",
    apiUrl: "https://1byun2hq08.execute-api.us-west-2.amazonaws.com/prod",
    auth: {
      authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_uqazlzUd7",
      client_id: "1485j17ri0ng28luc7bd0373ve",
      redirect_uri: "https://d1obq4snzch1gj.cloudfront.net/",
      post_logout_redirect_uri: "https://d1obq4snzch1gj.cloudfront.net/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
      // Skip Cognito hosted UI and go directly to Amazon Federate (Midway SSO)
      extraQueryParams: { identity_provider: "FederateOIDC" },
    },
  },
  test: {
    redirectUri: "https://test-environment.d12ztxlr9f4r1j.amplifyapp.com/",
    logoutUri: "https://test-environment.d12ztxlr9f4r1j.amplifyapp.com/",
    apiEndpoint: "bedrock", // Uses bedrock backend environment
    apiUrl: "https://api-test.coachai.csld.amazon.dev",
  },
  bedrockTest: {
    redirectUri: "https://bedrock-test.d12ztxlr9f4r1j.amplifyapp.com/",
    logoutUri: "https://bedrock-test.d12ztxlr9f4r1j.amplifyapp.com/",
    apiEndpoint: "bobbie", // Uses bobbie backend environment
    apiUrl: "https://api-bedrock.coachai.csld.amazon.dev",
  },
  // Beta — served by the pipeline's Beta stage on coachai-b.csld.amazon.dev
  // (CloudFront distribution d3efdkdruxwi32). Points at the hand-created Beta
  // backend in us-east-1, which is NOT managed by CDK.
  beta: {
    redirectUri: "https://coachai-b.csld.amazon.dev/",
    logoutUri: "https://coachai-b.csld.amazon.dev/",
    apiEndpoint: "bedrock", // Uses original working API with JWT auth
    apiUrl: "https://cm2yoapsi8.execute-api.us-east-1.amazonaws.com/bobbie",
    // OIDC configuration for Cognito + Amazon Federate + Midway
    auth: {
      authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_WqDymJ50t",
      client_id: "2elbk24054arsa4mg1ndlap9o7",
      redirect_uri: "https://coachai-b.csld.amazon.dev/",
      post_logout_redirect_uri: "https://coachai-b.csld.amazon.dev/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
    },
  },
  // Prod smoke-test config — used when running locally against real Prod resources.
  // Start dev server with: REACT_APP_ENV=prodtest npm run server
  // Cognito will redirect back to localhost:4321 after login.
  // Prod resources: API Gateway us-west-2, Cognito us-west-2_uqazlzUd7
  prodTest: {
    redirectUri: "http://localhost:4321/",
    logoutUri: "http://localhost:4321/",
    apiEndpoint: "bedrock",
    apiUrl: "https://1byun2hq08.execute-api.us-west-2.amazonaws.com/prod",
    auth: {
      authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_uqazlzUd7",
      client_id: "1485j17ri0ng28luc7bd0373ve",
      redirect_uri: "http://localhost:4321/",
      post_logout_redirect_uri: "http://localhost:4321/",
      scope: "aws.cognito.signin.user.admin email openid profile",
      response_type: "code",
      automaticSilentRenew: true,
      loadUserInfo: true,
    },
  },
  development: {
    redirectUri: "http://localhost:4321/",
    logoutUri: "http://localhost:4321/",
    apiEndpoint: "local", // Uses local development API
    apiUrl: "http://localhost:3001", // Local API server for development
  },
};

export const isProduction = window.location.hostname === "coachai.csld.amazon.dev";
export const isTest = window.location.hostname === "test-environment.d12ztxlr9f4r1j.amplifyapp.com";
export const isBedrockTest = window.location.hostname === "bedrock-test.d12ztxlr9f4r1j.amplifyapp.com";
// Beta custom domain, served by the Beta stage.
export const isBeta = window.location.hostname === "coachai-b.csld.amazon.dev";
// The Beta stage's own CloudFront domain, behind coachai-b.csld.amazon.dev.
// Hitting it directly serves Beta assets, so it takes the Beta config.
export const isBetaCloudFront = window.location.hostname === "d3efdkdruxwi32.cloudfront.net";
// The Prod stage's own CloudFront domain, behind coachai.csld.amazon.dev.
export const isProdCloudFront = window.location.hostname === "d1obq4snzch1gj.cloudfront.net";
// Prod smoke-test: set REACT_APP_ENV=prodtest to test against real Prod resources locally
export const isProdTest = process.env.REACT_APP_ENV === 'prodtest';
export const currentConfig = isProdTest
  ? config.prodTest
  : isProdCloudFront
  ? config.prodCloudFront
  : isProduction
  ? config.production
  : isTest
  ? config.test
  : isBedrockTest
  ? config.bedrockTest
  : isBeta
  ? config.beta
  : isBetaCloudFront
  ? config.beta // Beta's own CloudFront domain serves Beta assets
  : config.development;

// Local development mode detection
export const isLocalDevelopment = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "0.0.0.0";
export const LOCAL_DEV_MODE = process.env.NODE_ENV === 'development' && isLocalDevelopment;
